import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

type ViteImportMeta = ImportMeta & {
  env: Record<string, string | boolean | undefined>;
};

export const env = createEnv({
  clientPrefix: "VITE_",
  client: {
    VITE_SERVER_URL: z.url(),
    VITE_SITE_URL: z.url(),
    // PostHog product analytics. Optional so local/dev builds without a key
    // still run — the analytics provider passes through when the key is unset.
    // The project key is a write-only ingestion key, safe to expose to the browser.
    VITE_POSTHOG_KEY: z.string().min(1).optional(),
    VITE_POSTHOG_HOST: z.url().optional(),
    // Cloudflare Turnstile widget SITE key, which protects the public contact
    // form. Public by design — it ships in the page HTML. Optional so builds
    // without a widget still run: the form renders no challenge and the server
    // skips verification (except in production, which fails closed). Must pair
    // with the server's TURNSTILE_SECRET_KEY — swap both halves together.
    VITE_TURNSTILE_SITE_KEY: z.string().min(1).optional(),
  },
  // SAFETY: `ViteImportMeta` names the `env` record Vite injects at build
  // time. The ambient `ImportMeta` here comes from the Workers types, which
  // have no `env` — this only adds the member Vite guarantees is present.
  runtimeEnv: (import.meta as ViteImportMeta).env,
  emptyStringAsUndefined: true,
});
